export const STACK_ARCHITECTURE = [
  { stack: 'data',           owns: 'DynamoDB tables, S3 buckets, SQS queues, Lambda layers',    deps: '—' },
  { stack: 'authentication', owns: 'Cognito User Pools (rider/driver + admin portal)',           deps: 'data' },
  { stack: 'location',       owns: 'AWS Location Service tracker & geofences',                  deps: '—' },
  { stack: 'ride',           owns: 'Ride request, matching, trip lifecycle APIs',               deps: 'data, authentication, location' },
  { stack: 'driver',         owns: 'Driver status, earnings, cashout APIs',                     deps: 'data, authentication, location' },
  { stack: 'rider',          owns: 'Rider profile, cash payment, notifications APIs',           deps: 'data, authentication, location' },
  { stack: 'payment',        owns: 'Paystack, MTN MoMo, Orange Money processing',                deps: 'data, authentication' },
  { stack: 'kyc',            owns: 'Document upload and verification',                          deps: 'data, authentication' },
  { stack: 'admin',          owns: 'Admin portal API, S3 + CloudFront hosting',                 deps: 'data, authentication, error-logging, location' },
  { stack: 'error-logging',  owns: 'Firehose pipelines, error log S3 bucket',                  deps: '—' },
  { stack: 'core',           owns: 'Public config API (AppSync endpoints, Cognito IDs)',        deps: 'data, error-logging' },
  { stack: 'website',        owns: 'Public marketing website (CloudFront + S3)',                deps: '—' },
];

export const DESIGN_DECISIONS_DONE = [
  <>No cross-stack CloudFormation exports — stacks communicate via SSM Parameter Store at runtime, preventing export lock-in</>,
  <>AppSync API IDs written to SSM by each API stack (<code>/libride/{'{'}'env{'}'}/ride-api-id</code> etc.) and read by lambdas at runtime</>,
  <>Lambda layers (Twilio, Python requests, utils) published once and referenced by ARN from SSM (<code>PARAM_KEYS</code> in <code>layers-utils.ts</code>)</>,
  <>All queues have Dead Letter Queues (DLQs) — failed messages are retained for investigation, not silently dropped</>,
  <>Serverless-first: no EC2, no containers — Lambda + DynamoDB + AppSync throughout</>,
  <>cdk-nag runs on every <code>cdk synth</code> — AWS Solutions checks block deployment on security violations</>,
];

export const DESIGN_DECISIONS_TODO: string[] = [];

export const CDK_COMMANDS = `# Install dependencies
npm install

# Synthesize all stacks (generates CloudFormation in cdk.out/)
npm run synth

# Synthesize a single stack
npx cdk synth libride-dev-v2-admin

# Diff a stack against deployed state
npx cdk diff libride-dev-v2-ride

# Run security checks only (no deploy)
CDK_NAG=true npm run synth

# Lint TypeScript
npm run lint`;

export const ENV_VARS = [
  { variable: 'ENVIRONMENT',         purpose: 'Deployment tier — drives all resource naming and SSM paths', example: 'dev / uat / prod' },
  { variable: 'CDK_DEFAULT_ACCOUNT', purpose: 'Target AWS account ID',                                      example: '502309351201' },
  { variable: 'CDK_DEFAULT_REGION',  purpose: 'Target AWS region',                                          example: 'us-east-1' },
  { variable: 'HOSTED_ZONE_NAME',    purpose: 'Route 53 hosted zone for custom domains',                    example: 'dev.libride.org' },
  { variable: 'SUPPORT_PHONE',       purpose: 'Twilio support phone number for call proxy',                 example: '+1234567890' },
  { variable: 'CDK_NAG',             purpose: 'Set to false to skip security checks during development',    example: 'false' },
];
